var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"logo",attrs:{"src":_vm.source,"alt":"Bell Oldow, Inc."}})
}
var staticRenderFns = []

export { render, staticRenderFns }